import request from '@/utils/request'

// 查询平台分账接收方分页
export function pagePlatformLedgerReceiver(data) {
  return request({
    url: '/biz/platform/ledger/receiver/page',
    method: 'post',
    data: data
  })
}

// 查询平台分账接收方列表
export function listPlatformLedgerReceiver(data) {
  return request({
    url: '/biz/platform/ledger/receiver/list',
    method: 'post',
    data: data
  })
}

// 查询平台分账接收方详情
export function getPlatformLedgerReceiver(params) {
  return request({
    url: '/biz/platform/ledger/receiver/detail',
    method: 'get',
    params: params
  })
}

// 新增平台分账接收方
export function addPlatformLedgerReceiver(data) {
  return request({
    url: '/biz/platform/ledger/receiver/add',
    method: 'post',
    data: data
  })
}

// 修改平台分账接收方
export function updatePlatformLedgerReceiver(data) {
  return request({
    url: '/biz/platform/ledger/receiver/edit',
    method: 'post',
    data: data
  })
}

// 删除平台分账接收方
export function delPlatformLedgerReceiver(data) {
  return request({
    url: '/biz/platform/ledger/receiver/delete',
    method: 'post',
    data: data
  })
}

// 创建拉卡拉平台分账接收方（对公）
export function applyPlatformLedgerReceiver(data) {
  return request({
    url: '/biz/platform/ledger/receiver/apply',
    method: 'post',
    data: data
  })
}

// 变更拉卡拉平台分账接收方（对公）
export function modifyPlatformLedgerReceiver(data) {
  return request({
    url: '/biz/platform/ledger/receiver/modify',
    method: 'post',
    data: data
  })
}

// 根据开户行名称查询开户行号与清算行号
export function queryBankBranch(data) {
  return request({
    url: '/biz/platform/ledger/receiver/queryBankBranch',
    method: 'post',
    data: data
  })
}
